export const REAL_ESTATE_VIEWPORT_LIMIT = 250;
export const REAL_ESTATE_CLIENT_VIEW_LIST_PAGE_SIZE = 200;
export const REAL_ESTATE_VIEWPORT_DEBOUNCE_MS = 550;

export const TRANSACTION_TYPE_OPTIONS = [
  { id: "", label: "All" },
  { id: "sale", label: "Sale" },
  { id: "rent", label: "Rent" },
  { id: "short_term_rental", label: "Short-term rental" },
  { id: "land", label: "Land" },
  { id: "commercial", label: "Commercial" },
];

export const PROPERTY_TYPE_OPTIONS = [
  { id: "", label: "All" },
  { id: "apartment", label: "Apartment" },
  { id: "house", label: "House" },
  { id: "land", label: "Land" },
  { id: "commercial", label: "Commercial" },
  { id: "mixed_use", label: "Mixed Use" },
];

export const LISTING_STATUS_OPTIONS = [
  { id: "", label: "All" },
  { id: "active", label: "Active" },
  { id: "pending", label: "Pending" },
  { id: "sold", label: "Sold" },
  { id: "rented", label: "Rented" },
  { id: "off_market", label: "Off Market" },
];

export const BROKER_SOURCE_OPTIONS = [
  { id: "LIV_REALTY", label: "LIV Realty Medellín" },
  { id: "ACRECER", label: "Acrecer" },
  { id: "LONDONO_GOMEZ", label: "Londoño Gómez" },
  { id: "ARRENDAMIENTOS_ENVIGADO", label: "Arrendamientos Envigado" },
  { id: "ABAD_FACIOLINCE", label: "Abad Faciolince" },
  { id: "MB_INMOBILIARIA", label: "MB Inmobiliaria" },
  { id: "MAESTRANZA", label: "Maestranza" },
  { id: "MEDELLIN_LIVING", label: "Medellín Living Real Estate" },
  { id: "ALBERTO_ALVAREZ", label: "Alberto Álvarez Inmobiliaria" },
  { id: "DUQUE_GIRALDO", label: "Duque Giraldo" },
  { id: "SANTILLANA", label: "Inmobiliaria Santillana" },
  { id: "HABITAMOS", label: "Habitamos" },
  { id: "MATTIS", label: "Mattis Inmobiliaria" },
  { id: "CONALTURA", label: "Conaltura Inmobiliaria" },
  { id: "SANTAFE", label: "Arrendamientos Santafé" },
  { id: "AYURA", label: "Arrendamientos Ayurá" },
  { id: "ALAMEDA", label: "Alameda Inmobiliaria" },
  { id: "PUNTO_RAIZ", label: "Inmobiliaria Punto Raíz" },
  { id: "NUTIBARA", label: "Arrendamientos Nutibara" },
  { id: "CONINSA", label: "Coninsa" },
  { id: "CASACOL", label: "Casacol Listings" },
  { id: "PRIMAVERA_REALTY", label: "Primavera Realty" },
  { id: "VALLEY_REALTY", label: "Valley Realty" },
  { id: "WELCOME_TO_MEDELLIN", label: "Welcome To Medellín" },
  { id: "MEDELLIN_ADVISORS", label: "Medellín Advisors" },
  { id: "VENPRO_RAIZ", label: "Venpro Raíz" },
  { id: "DATO_INMOBILIARIO", label: "DATO Inmobiliario" },
  { id: "BATTECA_GROUP", label: "Batteca Group" },
  { id: "EURO_INMOBILIARIA", label: "Euro Inmobiliaria" },
  { id: "OCCIDENTE_ANTIOQUENO", label: "Inmobiliaria Occidente Antioqueño" },
  { id: "SUROESTE_FINCA_RAIZ", label: "Suroeste Finca Raíz" },
  { id: "ENCUENTRA_TU_FINCA", label: "Encuentra Tu Finca" },
  { id: "HOMDLY", label: "HOMDLY" },
  { id: "ISAZA_INMOBILIARIA", label: "Inmobiliaria Isaza" },
  { id: "DERANOVA", label: "Deranova" },
  { id: "CASA_FINCA_RAIZ", label: "CasaFincaRaíz" },
  { id: "SUROESTE_REALTORS", label: "Suroeste Realtors Propiedades" },
  { id: "SOL_Y_MAR", label: "Sol y Mar Inmobiliaria" },
  { id: "ALTA_VISION", label: "Alta Visión Inmobiliaria" },
  { id: "NATURAVIVIENDA", label: "NaturaVivienda" },
  { id: "CENTURY21_LA_HEREDAD", label: "Century 21 La Heredad" },
  { id: "AREA_VITAL", label: "Área Vital Inmobiliaria" },
  { id: "GRUPO_JURIDICO_OCCIDENTE", label: "Grupo Jurídico e Inmobiliario del Occidente" },
  { id: "SYNERGY_PROPIEDAD_RAIZ", label: "Synergy Propiedad Raíz" },
  { id: "CONFORT_SOPETRAN", label: "Inmobiliaria Confort Sopetrán" },
  { id: "CASAS_Y_ESPACIOS", label: "Casas & Espacios" },
  { id: "OPRA_INMOBILIARIA", label: "OPRA Inmobiliaria" },
  { id: "SINITABE", label: "Sinitabé Propiedad Raíz" },
  { id: "ORIENTE_RAIZ", label: "Oriente Raíz" },
  { id: "ENTRECASAS", label: "EntreCasas" },
];

export const INITIAL_BROKER_SOURCE_SELECTION = {
  LIV_REALTY: true,
  ACRECER: true,
  LONDONO_GOMEZ: true,
  ARRENDAMIENTOS_ENVIGADO: true,
  ABAD_FACIOLINCE: true,
  MB_INMOBILIARIA: true,
  MAESTRANZA: true,
  MEDELLIN_LIVING: true,
  ALBERTO_ALVAREZ: true,
  DUQUE_GIRALDO: true,
  SANTILLANA: true,
  HABITAMOS: true,
  MATTIS: true,
  CONALTURA: true,
  SANTAFE: true,
  AYURA: true,
  ALAMEDA: true,
  PUNTO_RAIZ: true,
  NUTIBARA: true,
  CONINSA: true,
  CASACOL: true,
  PRIMAVERA_REALTY: true,
  VALLEY_REALTY: true,
  WELCOME_TO_MEDELLIN: true,
  MEDELLIN_ADVISORS: true,
  VENPRO_RAIZ: true,
  DATO_INMOBILIARIO: true,
  BATTECA_GROUP: true,
  EURO_INMOBILIARIA: true,
  OCCIDENTE_ANTIOQUENO: true,
  SUROESTE_FINCA_RAIZ: true,
  ENCUENTRA_TU_FINCA: true,
  HOMDLY: true,
  ISAZA_INMOBILIARIA: true,
  DERANOVA: true,
  CASA_FINCA_RAIZ: true,
  SUROESTE_REALTORS: true,
  SOL_Y_MAR: true,
  ALTA_VISION: true,
  NATURAVIVIENDA: true,
  CENTURY21_LA_HEREDAD: true,
  AREA_VITAL: true,
  GRUPO_JURIDICO_OCCIDENTE: true,
  SYNERGY_PROPIEDAD_RAIZ: true,
  CONFORT_SOPETRAN: true,
  CASAS_Y_ESPACIOS: true,
  OPRA_INMOBILIARIA: true,
  SINITABE: true,
  ORIENTE_RAIZ: true,
  ENTRECASAS: true,
};

export const FRESHNESS_FILTER_OPTIONS = [
  { id: "", label: "Any freshness" },
  { id: "today", label: "Seen today" },
  { id: "recent", label: "Recently updated (3 days)" },
  { id: "week", label: "Seen this week" },
  { id: "stale", label: "Needs verification" },
];

export const AVAILABILITY_FILTER_OPTIONS = [
  { id: "", label: "Any availability" },
  { id: "AVAILABLE", label: "Available" },
  { id: "PENDING_REVIEW", label: "Needs verification" },
];

export const INITIAL_REAL_ESTATE_FILTERS = {
  transactionType: "rent",
  propertyType: "",
  listingStatus: "",
  minPrice: "",
  maxPrice: "",
  minBedrooms: "",
  minBathrooms: "",
  minBuildingAreaSqM: "",
  maxBuildingAreaSqM: "",
  neighborhood: "",
  municipality: "",
  searchQuery: "",
  sourceKey: "",
  locationLabel: "",
  freshness: "",
  availabilityStatus: "",
  brokerSources: { ...INITIAL_BROKER_SOURCE_SELECTION },
};

export function hasBrokerSourcesSelected(brokerSources = {}) {
  return BROKER_SOURCE_OPTIONS.some((option) => brokerSources[option.id]);
}

/**
 * Returns comma-separated broker source codes, or:
 * - undefined when all sources are selected (backend returns all)
 * - null when no sources are selected (caller should skip fetch)
 */
export function buildBrokerSourcesParam(brokerSources = {}) {
  const selected = BROKER_SOURCE_OPTIONS.map((option) => option.id).filter(
    (id) => brokerSources[id]
  );

  if (!selected.length) {
    return null;
  }

  if (selected.length === BROKER_SOURCE_OPTIONS.length) {
    return undefined;
  }

  return selected.join(",");
}

export function getBrokerSourceLabel(sourceId) {
  return BROKER_SOURCE_OPTIONS.find((option) => option.id === sourceId)?.label || sourceId;
}

function buildSharedListingFilters(filters = {}, context = {}) {
  const sources = buildBrokerSourcesParam(filters.brokerSources);
  const query = {
    areaId: context.areaId || undefined,
    bbox: context.bbox,
    zoom: context.zoom,
    sort: context.sort || undefined,
    limit: context.limit,
    offset: context.offset,
    listingType: filters.transactionType || undefined,
    propertyType: filters.propertyType || undefined,
    listingStatus: filters.listingStatus || undefined,
    minPrice: filters.minPrice || undefined,
    maxPrice: filters.maxPrice || undefined,
    minBedrooms: filters.minBedrooms || undefined,
    minBathrooms: filters.minBathrooms || undefined,
    minBuildingAreaSqM: filters.minBuildingAreaSqM || undefined,
    maxBuildingAreaSqM: filters.maxBuildingAreaSqM || undefined,
    neighborhood: filters.neighborhood || undefined,
    municipality: filters.municipality || undefined,
    freshness: filters.freshness || undefined,
    availabilityStatus: filters.availabilityStatus || undefined,
    search: filters.searchQuery || undefined,
    q: filters.searchQuery || undefined,
  };

  if (sources) {
    query.sources = sources;
  }

  const sourceKey = context.sourceKey || filters.sourceKey;
  if (sourceKey) {
    query.sourceKey = sourceKey;
  }

  return query;
}

export function buildListingQueryFilters(filters = {}, context = {}) {
  return buildSharedListingFilters(filters, context);
}

export function buildPropertyQueryFilters(filters = {}, context = {}) {
  const query = buildSharedListingFilters(filters, context);
  return {
    ...query,
    transactionType: filters.transactionType || undefined,
  };
}

/**
 * Map-driven public search: bbox + listing type + q only (no broker/area filters).
 */
export function buildPublicPropertyQueryFilters(filters = {}, context = {}) {
  const center = context.center;
  const sort = filters.searchQuery?.trim() ? "relevance" : context.sort || "recent";

  const query = {
    bbox: context.bbox,
    zoom: context.zoom,
    limit: context.limit,
    offset: context.offset,
    sort,
    listingType: filters.transactionType || undefined,
    q: filters.searchQuery?.trim() || undefined,
    search: filters.searchQuery?.trim() || undefined,
    boundary_id: context.boundaryId || filters.boundaryId || undefined,
    market_zone_id: context.marketZoneId || filters.marketZoneId || undefined,
    include_boundary_context: context.includeBoundaryContext ? "true" : undefined,
  };

  if (context.clientViewSlug) {
    query.clientViewSlug = context.clientViewSlug;
  } else if (context.clientViewId) {
    query.clientViewId = context.clientViewId;
  }

  if (center) {
    query.center = `${center.lng},${center.lat}`;
  }

  return query;
}
